// Configuration values for the application
const CONFIG = {
  // Maximum allowed file size in bytes
  UPLOAD_MAX_FILE_SIZE: 100 * 1024 * 1024,

  // Maximum allowed sum(events) in bytes to be sent in a single sync request
  SYNC_MAX_BATCH_SIZE_BYTES: 40 * 1024 * 1024,

  // Maximum number of events per sync request (dependency chains may exceed it — they are
  // never split). Smaller batches make the user-visible "X of Y synced" progress tick and
  // contain failures better; the cost is a few more HTTP round-trips on large queues.
  SYNC_MAX_BATCH_EVENT_COUNT: 8,

  // Delay in milliseconds for auto-sync
  // This is the time to wait before sending the next sync request
  AUTO_SYNC_DELAY_MS: 1 * 1000,

  // Maximum number of concurrent BRouter route requests for bounded reroute batches
  BROUTER_MAX_CONCURRENT_REQUESTS: 2,

  // Toggle invite-only account signup in the web UI.
  // When enabled, the signup form requires an invite code field.
  INVITE_ONLY_SIGNUP_ENABLED: true,
}

export default CONFIG
